export default {
    "label.update_translations_unsuccessful": "{count} položiek zlyhalo:",
    "global.no_records": "Žiadne záznamy",
    "notifications.rp_has_been_updated": "Rezidenčný projekt bol aktualizovaný",
    "moduleTitle.files": "Súbory",
    "label.coordinator": "Koordinátor",
    "sidebar.translations_managment": "Správca prekladov",
    "table.file": "Súbor",
    "label.report_overview": "Prehľad",
    "label.parent_agreement": "Súhlas rodiča",
    "parentalConsent.i_consent_to_and_understand_that": "6. Súhlasím a beriem na vedomie, že počas účasti účastníka na niektorých aktivitách týkajúcich sa programu DofE môžu byť vyhotovované fotografie, videozáznamy alebo iné nahrávky („záznamy“) a že tieto záznamy môžu byť použité na propagačné účely. Týmto súhlasím s primeraným použitím na propagačné účely a súhlasím a beriem na vedomie, že na primerané propagačné použitie takýchto záznamov sa nebude vyžadovať žiadny ďalší súhlas (privolenie) účastníka ani jeho/jej rodičov / zákonných zástupcov.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Beriem na vedomie, že účastníci sú povinní dodržiavať podmienky programu DofE, uvedené v Účastníckej knižke alebo v ORB, predpisy a štandardy správania príslušného Miestneho centra (v ich platnom znení) a požiadavky Miestneho centra týkajúce sa plánov pohotovosti, hodnotenia aktivít a vedenia Dobrodružných expedícií týkajúcich sa programu DofE, a beriem na vedomie, že Miestne centrum môže vziať späť svoj súhlas s účasťou účastníka v programu DofE v prípade jeho nesúladu s uvedenými podmienkami.",
    "table.end_date": "Dátum dokončenia",
    "label.activation_date": "Dátum aktivácie",
    "label.report": "Správa",
    "label.award_is_offline": "Režim pre ocenenie je papierový",
    "label.pending_changes": "Čaká na zmeny...",
    "errors.min_nights_required": "Požaduje sa minimálne tento počet nocí: {nights}",
    "label.country": "Krajina",
    "notifications.award_leader_has_been_returned": "Vedúci programu bol vrátený",
    "notifications.participant_has_been_updated": "Údaje účastníka boli aktualizované",
    "label.phone_number": "Telefónne číslo",
    "roles.aj_assessor": "Hodnotiteľ dobrodružnej expedície",
    "notifications.person_state_has_been_changed": "Stav osoby sa zmenil",
    "pageTitle.dashboard": "Tabuľa",
    "moduleTitle.global_payment_method": "Globálna metóda úhrady",
    "label.organization_type": "Typ organizácie",
    "button.account_settings": "Nastavenie konta",
    "notifications.contact_has_been_updated": "Kontakt bol aktualizovaný",
    "participant.recover_password": "Obnoviť heslo",
    "notifications.assessment_request_has_been_sent": "Odoslala sa žiadosť o vyhodnotenie",
    "button.unassign": "Zrušiť pridelenie",
    "label.start_date": "Dátum začiatku",
    "label.assign_labels": "Priraď štítky",
    "sidebar.participants": "Účastníci",
    "roles.coordinator": "Koordinátor",
    "label.organization_contact": "Kontakt na organizáciu",
    "tabs.customization": "Prispôsobenie",
    "sidebar.award_units": "Miestne centrá",
    "button.change_goal": "Zmeniť cieľ",
    "translationsManagement.selectProject": "Vybrať projekt",
    "award.rp": "Rezidenčný projekt",
    "label.size": "Veľkosť",
    "label.bulk_action_results": "Výsledky hromadnej zmeny",
    "notifications.activity_has_been_approved": "Aktivita bola schválená",
    "label.payment_type": "Typ platby",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Znova odoslať žiadosť o vyhodnotenie",
    "notifications.template_has_been_removed": "Šablóna bola odstránená",
    "button.award_settings": "Nastavenia DofE",
    "pageTitle.payment": "Platba",
    "tasks.return_award": "Vrátiť DofE",
    "label.link": "prepojenie",
    "moduleTitle.award_participant_delete": "Vymazať účastníkove ocenenie",
    "pageTitle.mro_related_contacts": "Moja oblastná kancelária – Súvisiace kontakty",
    "pageTitle.my_organization_labels": "Moja organizácia - Štítky",
    "tabs.activity_signoff": "Schválenie oblasti",
    "table.logs": "Záznamy",
    "moduleTitle.remove_file": "Odstrániť súbor?",
    "label.email_confirmed": "E-mail bol potvrdený",
    "notifications.activity_has_been_returned": "Aktivita bola vrátená",
    "label.note": "Poznámka",
    "button.show": "Zobraziť",
    "tabs.adventurous_journey": "Dobrodružná expedícia",
    "sidebar.my_todolist": "Môj zoznam úloh",
    "label.here": "sem",
    "organisation.change_award_mode": "Zmeniť režim ocenenia",
    "table.note_from_al": "Poznámka od Vedúceho",
    "label.gender": "Pohlavie",
    "moduleTitle.remove": "Odstrániť?",
    "errors.must_be_less_than": "Musí byť menej ako {limit}",
    "button.logout": "Odhlásenie",
    "label.no_selected_participants": "Nie sú vybratí žiadni účastníci",
    "button.new_aj_event": "Nová udalosť v rámci dobrodružnej expedície",
    "label.employement_status": "Zamestnanie (stav)",
    "tabs.logs": "Záznamy",
    "tabs.contacts": "Kontakty",
    "label.option": "Možnosť",
    "dashboard.charts": "Grafy",
    "notifications.rp_has_been_approved": "Rezidenčný projekt bol schválený",
    "pageTitle.new_participant": "Nový účastník",
    "notifications.award_leader_has_been_approved": "Vedúci programu bol schválený",
    "moduleTitle.would_you_like_to_remove_leader_training": "Chcete odstrániť tréning Vedúceho programu?",
    "moduleTitle.update_configuration_value": "Aktualizovať hodnotu konfigurácie",
    "table.description": "Popis",
    "table.organization": "Organizácia",
    "label.youtube": "YouTube",
    "label.author": "Autor",
    "table.suitable_for_award_level": "Vhodné pre úroveň DofE",
    "label.content_update": "Čakajte, prosím. Aktualizuje sa obsah...",
    "notifications.new_question_has_been_added": "Pridala sa nová otázka",
    "pageTitle.nao_awards": "Národná kancelária – Ocenenia",
    "table.last_name": "Priezvisko",
    "moduleTitle.adventurous_journey_detail": "Podrobnosti expedície",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Hromadná úprava"},
    "label.project_location_type": "Typ miesta projektu",
    "label.email_help_award_level": "Úroveň programu.",
    "label.date": "Dátum",
    "label.previous_completed_award_place": "Miesto konania",
    "button.show_more": "Zobraziť viac",
    "label.wwc_number": "Číslo WWC",
    "button.filter": "Filter",
    "notifications.rp_has_been_returned": "Rezidenčný projekt bol vrátený",
    "pageTitle.residetial_project_assessor_report": "Rezidenčný projekt – správa hodnotiteľa",
    "label.generating": "Vytváranie...",
    "moduleTitle.finance_system_data": "Finančné údaje",
    "notifications.adventurous_journey_state_has_been_changed": "Stav dobrodružnej expedície sa zmenil",
    "route.levels": "Úrovne",
    "moduleTitle.activity_leader": "Vedúci aktivity",
    "tasks.approve_event": "Schváliť udalosť",
    "tasks.reject_event": "Zamietnuť udalosť",
    "table.region": "Región",
    "pageTitle.nao_award_leaders": "Národná kancelária – Vedúci programu",
    "errors.must_be_at_least": "Musí obsahovať minimálne tento počet znakov: {min}",
    "table.title": "Titul",
    "table.last_activity": "Posledná aktivita",
    "tasks.delete_registration": "Odstrániť registráciu",
    "table.date_time": "Dátum / čas",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Miestne centrum a Národná kancelária sa zaväzujú rešpektovať Vaše súkromie. Osobné údaje sa v tomto formulári zhromažďujú za účelom účasti v programe DofE. Účastníci, ktorí nám neposkytnú tieto údaje, sa nemôžu zúčastniť na programe DofE (uvedené sa nevzťahuje na neposkytnutie údajov o účastníkovi). Údaje môžeme použiť aj pre účely zasielania informácií o iných aktivitách alebo podujatiach v rámci programu DofE, ktoré by Vás mohli zaujímať. Údaje môžeme poskytnúť aj iným miestnym, verejným alebo medzinárodným organizáciám a poskytovateľom služieb, ktorí nám pomáhajú alebo nás podporujú v prevádzkovaní alebo v poskytovaní programu DofE. Ak nás chcete kontaktovať alebo pristupovať k Vašim osobným údajom, napíšte prosím svojmu Miestnemu centru.",
    "aj.practice_journey": "Cvičná expedícia",
    "notification.log_has_been_restored": "Záznam aktivity bol obnovený",
    "tabs.my_participants": "Moji účastníci",
    "label.bulk_action_assign_label": "Priradiť štítok",
    "moduleTitle.supervisor": "Školiteľ",
    "moduleTitle.your_parental_consent": "Váš súhlas rodiča",
    "route.registration_participants": "Účastníci registrácie",
    "placeholder.start_typing": "Začať písať...",
    "tasks.approve_award": "Schváliť DofE",
    "route.registrations": "Registrácie",
    "button.add_activity": "Pridať aktivitu",
    "notifications.aj_event_has_been_created": "Dobrodružná expedícia bola vytvorená",
    "states.supervisor_approval": "Schválenie hodnotiteľom",
    "label.description": "Popis",
    "button.leave_anyway": "Opustiť aj v tomto prípade",
    "tabs.registrations": "Registrácie",
    "states.leader_signoff": "Autorizácia sekcie",
    "moduleTitle.forbidden": "Zakázané",
    "notifications.translations_has_been_updated.button": "Preklady sa úspešne načítali",
    "pageTitle.nao_registration": "Národná kancelária – Registrácia",
    "pageTitle.mro_logs": "Moja oblastná kancelária – Záznamy",
    "meta.page_not_found": "Stránka nenájdená",
    "label.bulk_action_unsuccessful": "Zlyhalo {count} položiek:",
    "global.days": "dni/dní",
    "table.review": "Prehodnotiť",
    "table.as_assessor_for": "Hodnotiteľ účastníka",
    "roles.if_staff_statistical_user": "Bežný používateľ \u000F– nadácia DofE",
    "table.levels": "Úrovne",
    "label.suitable_for_level": "Vhodné pre úroveň",
    "pageTitle.leaders": "Vedúci",
    "moduleTitle.send_test_email": "Odoslať testovací e-mail",
    "pageTitle.tasks_removed_registration": "Odstránené registrácie účastníka",
    "label.you_will_be_forced_to_login_again_after_change": "Po zmene sa budete musieť znovu prihlásiť",
    "table.recent_updates": "Najnovšie aktualizácie",
    "pageTitle.tasks_activity_signoffs": "Schválenie oblasti",
    "pageTitle.payments": "Platby",
    "global.nights": "noci/nocí",
    "label.blank_any_level": "PRÁZDNE na akejkoľvek úrovni",
    "button.view_section": "Zobraziť sekciu",
    "moduleTitle.select_organization": "Vybrať organizáciu",
    "pageTitle.manual_data_import": "Manuálne nahrávanie dát",
    "button.upload_files": "Nahrať súbory",
    "label.migrated_contact_email": "E-mail migrovaného kontaktu",
    "label.for_award_unit": "Pre miestne centrum",
    "label.aj_template_note": "Poznámka v šablóne",
    "table.last_log_added": "Posledný záznam bol pridaný",
    "button.view_participant": "Od účastníka",
    "label.please_comment_on_the_participants": "Prosím, ohodnoťte zlepšenie/výkon/zapojenie účastníkov",
    "label.consent_already_given_login": "Súhlas už bol udelený. Prihláste sa s údajmi dieťaťa.",
    "participant.level_start_date": "Dátum začiatku {value}",
    "sidebar.my_region_office": "Moja regionálna kancelária",
    "states.section_signoff": "Schválenie oblasti",
    "moduleTitle.assessor_details": "Údaje hodnotiteľa",
    "moduleTitle.adventurous_journey_settings": "Nastavenie dobrodružnej expedície",
    "moduleTitle.note_from_al": "Poznámka od Vedúceho programu",
    "button.add_role": "Pridať rolu",
    "table.run": "Spustiť",
    "states.change_to_state_warning_missing_assessment": "UPOZORNENIE: Hodnotenie nebolo pridané. Napriek tomu chcete pokračovať?",
    "label.user_app_guide_leader": "Užívateľská príručka - Vedúci programu",
    "tabs.section_approval": "Schválenie oblasti",
    "roles.award_verifier": "Overovateľ DofE",
    "tabs.activity_approval": "Schválenie aktivity",
    "logs.add_log": "Pridať záznam",
    "tabs.award": "DofE",
    "notifications.this_role_has_read_only_persmission": "Táto rola má povolenie len na čitanie",
    "table.no_filtered_results": "Žiadne výsledky filtrovania",
    "button.praise": "Komentár",
    "label.prevent_welcome_email_assessor": "Neposielať uvítací email hodnotiteľovi",
    "label.location_detail": "Podrobnosti miesta",
    "label.optional": "(nepovinné)",
    "errors.do_not_match": "Nezhoduje sa",
    "label.use_comma_for_multiple_entries": "Použite čiarku pre viac položiek",
    "label.operating_authority": "Autorizovaný prevádzkovateľ",
    "label.activity_section": "Oblasť aktivity",
    "notifications.you_have_been_logged_out": "Prebehlo odhlásenie zo systému",
    "table.finished": "Hotovo",
    "button.same_as_billing": "Rovnaká adresa ako fakturačná",
    "table.payment": "Platba",
    "table.current_level": "Aktuálna úroveň",
    "button.view_nao": "Vrátené Národnou kanceláriou (s poznámkou o nutnosti úpravy)",
    "table.email_confirmation": "Potvrdenie e-mailu",
    "moduleTitle.shipping_address": "Adresa dodania",
    "label.secondary_phone_type": "Typ sekundárneho telefónu",
    "notifications.saved": "Uložené",
    "pageTitle.all_participants": "Všetci účastníci",
    "label.first_name": "Krstné meno",
    "label.oa_price": "Príspevok pre Miestne centrum",
    "table.award_mode": "Režim ocenenia",
    "tabs.api_keys": "Kľúče API",
    "award.award_detail": "Detail",
    "tabs.user_management": "Spravovanie účastníkov",
    "tabs.all_events": "Všetky udalosti",
    "notifications.history_record_has_been_removed": "Odstránil sa záznam histórie",
    "award.no_data": "Žiadne údaje",
    "notifications.preparation_training_has_been_added": "Príprava a tréning na dobrodružnú expedíciu boli pridané",
    "label.message": "Správa",
    "notifications.participant_info_updated": "Informácie o účastníkovi boli aktualizované",
    "roles.nao_staff": "Pracovník Národnej kancelárie",
    "tabs.adventurous_journeys": "Dobrodružné expedície",
    "label.gops": "Globálni autorizovaní prevádzkovatelia",
    "route.upload": "Nahrať",
    "notifications.history_record_has_been_added": "Pridal sa záznam histórie",
    "notifications.history_record_has_been_updated": "Aktualizoval sa záznam histórie",
    "label.no_data": "Žiadne údaje",
    "button.add_coordinator": "Pridať koordinátora",
    "label.you_are_already_logged_as": "Už ste sa prihlásili ako ",
    "route.my_national_office": "Moja národná kancelária",
    "tabs.leaders": "Vedúci programu",
    "label.email_confirmation": "Potvrdenie e-mailu",
    "table.registration_date": "Dátum registrácie",
    "notifications.role_has_been_removed": "Rola bola odstránená",
    "button.move": "Presunúť",
    "label.terms_and_conditions": "Pravidlá a podmienky",
    "pageTitle.detail": "Podrobnosti",
    "table.award_unit": "Miestne centrum",
    "sidebar.settings": "Nastavenia",
    "dashboard.leader_state": "Vedúci – podľa stavu",
    "notifications.award_unit_has_been_approved": "Vedúci programu bol schválený",
    "states.awaiting_approval": "Čaká na schválenie",
    "table.level": "Úroveň",
    "table.action_requested": "Vyžaduje sa akcia",
    "label.organisation_mode": "Režim organizácie",
    "label.no_note": "Žiadna poznámka",
    "tabs.my_events": "Moje udalosti",
    "notifications.participants_have_been_added": "Účastníci boli pridaní",
    "tabs.registration_questions": "",
    "button.delete_registration": "Odstrániť registráciu",
    "notifications.parental_consent_link_has_been_sent": "Odoslalo sa prepojenie na rodičovský súhlas",
    "moduleTitle.select_role_organization": "Vybrať rolu & organizáciu",
    "label.experience": "Skúsenosti",
    "translationsManagement.modal.title": "Chcete aktualizovať preklady?",
    "table.ic": "Nezávislá krajina",
    "table.id": "ID",
    "label.notify_email_explanation": "Účastník bude informovaný e-mailom, že jeho žiadosť o hodnotenie nebola doručená a bude vyzvaný, aby e-mail opravil a požiadal o hodnotenie znova.",
    "participant.would_you_like_to_remove": "Chcete toto konto odstrániť?",
    "table.fields_included": "Zahrnuté polia",
    "label.user_guide_web_leader": "Užívateľská príručka - Vedúci programu",
    "label.journey_type": "Typ expedície",
    "button.setup": "Nastaviť",
    "tabs.my_national_office": "Moja Národná kancelária DofE",
    "notifications.training_has_been_removed": "Tréning bol odstránený",
    "label.nominated_and_identified_persons": "Nominované a identifikované osoby, ktoré môžu zobraziť všetky údaje, ale nie ich upravovať",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Následkom vašej nečinnosti ste boli odhlásení",
    "states.award_leader_signoff": "Schválenie Vedúcim programu",
    "table.award_signoff_attempts": "Pokusy o schválenie DofE",
    "sidebar.regions": "Regióny",
    "label.activity_deleted_note": "Táto aktivita sa odstránila. Môžete ju obnoviť kliknutím na toto tlačidlo.",
    "table.total": "Spolu",
    "errors.a_problem_has_occured_during_processing": "Počas spracovania sa vyskytol problém, pozrite si ďalšie informácie",
    "participant.participant_already_has_gold_award": "Účastník už má Zlatú cenu",
    "pageTitle.mro": "Moja oblastná kancelária",
    "notifications.authorization_code_has_expired": "Platnosť potvrdzujúceho kódu vypršala",
    "moduleTitle.child_organization_labels": "Štítok mládežníckej organizácie",
    "aj.aj_events": "Udalosti dobrodružnej expedície",
    "global.loading": "Načítava sa",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Registrácie",
    "label.any_string": "Akýkoľvek reťazec",
    "contact.change_contact_status": "Zmeniť stav kontaktu",
    "tabs.registration": "Registrácia",
    "label.override_payment_note": "Prepísať poznámku o platbe",
    "notifications.section_has_been_signed_off": "Oblasť bola schválená",
    "label.payment_date": "Dátum platby",
    "button.approve": "Schváliť",
    "moduleTitle.loggin_in": "Prihlásenie",
    "label.website": "Webová lokalita",
    "label.role": "Rola",
    "table.assessor_report": "Správa Hodnotiteľa",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "Prosím, popíšte ako účastník demonštroval snahu pracovať na dosiahnutí cieľa v tejto aktivite",
    "label.previously_worked_as_assessor": "Predchádzajúca pozícia – hodnotiteľ",
    "pageTitle.registrations": "Registrácie",
    "parentalConsent.this_form_must_be_completed": "Tento formulár <strong>musí</strong> za účastníkov mladších ako <strong> 18 rokov/tých, ktorí nedosiali v krajine s trvalým pobytom vek právnej zodpovednosti </strong> vyplniť rodič alebo poručník.",
    "button.apply": "Aplikovať",
    "errors.include_at_least_one_number": "Súčasťou musí byť minimálne jedna číslica",
    "label.content_restore": "Obnovuje sa relácia",
    "logs.hour": "hodina",
    "parentalConsent.i_have_read_and_understand": "7. Prečítal som si a porozumel som rôznym úrovniam a požiadavkám programu DofE, ako sú uvedené v Prehľade programu DofE (strany 4 a 5 tohto formuláru).",
    "notifications.award_was_deleted": "Ocenenie bolo vymazané.",
    "label.journey_category": "Kategória expedície",
    "notifications.search_cancelled": "Vyhľadávanie bolo prerušené, musíte počkať na dokončenie vyhľadávania.",
    "route.detail": "Podrobnosti",
    "route.user_guide": "Užívateľská príručka",
    "moduleTitle.history": "História",
    "table.gop_name": "Globálny autorizovaný prevádzkovateľ",
    "pageTitle.tasks_unassigned_participants": "Nepriradení účastníci",
    "states.inactive": "Neaktívne",
    "pageTitle.search_results": "Výsledky vyhľadávania",
    "button.proceed_to_login": "Prejsť na prihlásenie",
    "pageTitle.assessor_report_reject": "Vrátenie správy Hodnotiteľa",
    "notifications.contact_has_been_removed": "Kontakt bol odstránený",
    "sidebar.operating_authorities": "Autorizovaní prevádzkovatelia",
    "label.no_note_from_participant": "Žiadna poznámka od účastníka",
    "aj.preparation_and_training": "Príprava a tréning",
    "route.user_guide_web_leader": "Užívateľská príručka - Vedúci programu",
    "label.position_in_organization": "Pozícia v organizácii",
    "errors.emails_dont_match": "E-maily sa nezhodujú",
    "route.my_participants": "Moji účastníci",
    "pageTitle.customisations": "Prispôsobenia",
    "tabs.localization_files": "Lokalizačné súbory",
    "table.assessor_approval": "Schválenie hodnotiteľom",
    "tabs.related_contacts": "Súvisiace kontakty",
    "table.aus": "Miestne centrá",
    "table.category": "Kategória",
    "errors.file_is_too_large": "Maximálna veľkosť nahraného súboru je 20MB",
    "label.possible_values": "Možné hodnoty:",
    "label.if_your_download_doesnt_start": "Ak sa vaše sťahovanie automaticky nespustí, kliknite sem",
    "route.independent_award_centres": "Nezávislé miestne centrá",
    "pageTitle.user_guide": "Užívateľská príručka",
    "button.visit": "Navštíviť",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Moja organizácia – podrobnosti",
    "pageTitle.nao_detail": "Národná kancelária – Podrobnosti",
    "button.change": "Zmeniť",
    "award.aj": "Dobrodružná expedícia",
    "table.award_state": "Stav DofE",
    "pageTitle.tasks_award_signoff": "Schválenie DofE",
    "pageTitle.regions": "Regióny",
    "notifications.award_has_been_signed_off": "DofE bolo schválené",
    "dashboard.award_approved_by": "Schválené ocenenia – podľa úrovne v roku 2016",
    "tabs.new_template": "Nová šablóna",
    "error.parent_email_must_be_filled": "E-mail rodiča musí byť vyplnený",
    "label.organisation_invoicing_name": "Fakturačný názov organizácie",
    "pageTitle.related_contacts": "Priradené kontakty",
    "button.try_again": "Zatvorte upozornenie a skúste to znova",
    "label.cannot_be_change_to_another": "Nie je možné zmeniť na inú úroveň DofE",
    "notifications.lead_coordinator_has_been_set": "Nový hlavný koordinátor nastavený",
    "label.training_name": "Názov tréningu",
    "moduleTitle.new_contact": "Nový kontakt",
    "translationsManagement.modal.updateTitle": "Ste si istí?",
    "moduleTitle.offline_award_units_signoff": "Schválenie Vedúcim programu pre papierový režim ocenenia",
    "notifications.award_level_has_been_changed": "Úroveň DofE sa zmenila",
    "label.subject": "Predmet",
    "route.silver_level": "Strieborná úroveň",
    "label.privacy_notice": "",
    "label.switch_organization": "Prepnúť organizáciu",
    "meta.dofe_name": "Medzinárodná cena vojvodu z Edinburghu",
    "route.profile": "Profil",
    "roles.super_user": "Používateľ s vyššími právami",
    "dashboard.while_you_were_gone": "Počas tvojej neprítomnosti",
    "label.no_note_from_award_leader": "Vrátené Národnou kanceláriou (bez poznámky o nutnosti úpravy)",
    "label.middle_name": "Druhé meno",
    "moduleTitle.new_activity": "Nová aktivita",
    "organisation.would_you_like_to_remove": "Chcete odstrániť túto organizáciu",
    "label.state_province": "Štát/oblasť/región",
    "moduleTitle.your_home_address": "Adresa domov",
    "tabs.sign_offs": "Schválenia",
    "moduleTitle.logs": "Záznamy",
    "button.view_more": "Zobraziť viac",
    "label.profile": "Profil",
    "label.title": "Titul",
    "tabs.award_signoff": "Schválenie DofE",
    "label.post_code": "PSČ",
    "states.ceremony_certificate": "Ceremónia a certifikát",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Súhlasím s poskytnutím osobných údajov, ktoré som poskytol (vrátane údajov účastníka, ktoré poskytol), Miestnemu centru a Národnej kancelárii. Súhlasím, aby sa s týmito údajmi nakladalo v súlade s ustanoveniami pravidiel ochrany súkromia príslušného Miestneho centra a Národnej kancelárie, s Národnými zásadami ochrany súkromia podľa Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri spracúvaní údajov a o voľnom pohybe takýchto údajov, ktorým sa zrušuje smernica 95/46/ES (všeobecné nariadenie o ochrane údajov) a v zmysle zákona č. 18/2018 Z. z. o ochrane osobných údajov. Tieto údaje môžu byť spracované na účel (i) zabezpečenia účasti účastníka v Programe DofE, (ii) overenia splnenia podmienok na získanie ocenenia DofE, (iii) účasti na odovzdávaní cien DofE, (iv) informovania o príležitostiach partnerov organizácií súvisiacimi s programom DofE (firemní, školskí, neziskoví, medzinárodní alebo iní), (v) pozvania účastníka do Alumni klubu programu DofE na Slovensku aj celosvetovo, (vi) vedenia evidencie registrovaných účastníkov pre čerpanie dotácie na prácu s mládežou v zmysle zákona č. 282/2008 Z. z. o podpore práce s mládežou v znení neskorších prepisov a na účel (vii) preukazovania vykonávania činnosti organizácie The Duke of Edinburgh’s International Award Slovensko, o.z. za účelom získania finančných prostriedkov na podporu činnosti tejto organizácie, pričom v takom prípade môžu byť osobné údaje v nevyhnutnom rozsahu (zvyčajne meno a priezvisko, rok narodenia, mesto a PSČ bydliska, Miestne centrum a kraj centra) poskytnuté orgánom daňovej kontroly, Ministerstvu školstva, vedy, výskumu a športu SR alebo IUVENTE – Slovenskému inštitútu mládeže.",
    "label.user_guide_web_participant": "Užívateľská príručka - Účastník",
    "label.award_unit_type": "Typ Miestneho centra",
    "states.complete": "Dokončené",
    "table.participant_state": "Stav účastníka",
    "pageTitle.my_organization_payment": "Moja organizácia – platba",
    "table.approved": "Schválené",
    "pageTitle.my_organization_contacts": "Moja organizácia – kontakty",
    "warning.award_marked_as_paid_registration": "Upozornenie: Existuje aspoň jedna úroveň ocenenia alebo registrácia označená ako zaplatená. Pred potvrdením si prečítajte pokyny pre platbu a vrátenie platby.",
    "states.change_to_state": "Zmeniť na stav <strong>{state}</strong>?",
    "label.integer": "Celé číslo",
    "notifications.translationUpdateInterrupted": "Aktualizácia bola prerušená",
    "notifications.password_has_been_changed": "Heslo bolo zmenené",
    "button.invite_assessor": "Pozvať hodnotiteľa",
    "label.other_activity": "Iná aktivita",
    "notifications.parental_consent_has_been_sent": "Súhlas rodiča bol odoslaný",
    "button.revise": "Revidovať",
    "errors.end_date_must_be_after_start_date": "Dátum ukončenia musí nasledovať po dátume začatia",
    "label.award_leader_signoff_date": "Dátum schválenia Vedúcim programu",
    "parentalConsent.i_understand_every_participant_must": "8. Beriem na vedomie, že každý účastník sa musí zúčastniť na programe DofE prostredníctvom Miestneho centra, ktorý má právo rozhodovať o prijatí alebo odmietnutí účastníkov, ako aj navrhovaných aktivít vykonávaných ako súčasť programu DofE.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Dobrodružná expedícia",
    "global.day": "deň",
    "moduleTitle.coordinator": "Koordinátor",
    "label.region": "Región",
    "button.add_history_record": "Pridať záznam histórie",
    "moduleTitle.adventurous_journey_template_settings": "Nastavenie šablóny dobrodružnej expedície",
    "notifications.personal_details_have_been_updated": "Osobné údaje boli aktualizované",
    "sidebar.ics": "Nezávislé krajiny (GBT)",
    "table.independent_award_centre": "Nezávislé centrum program",
    "label.undelivered_mail_reason": "Dôvod nedoručenia emailu",
    "table.utc_date_time": "UTC čas",
    "moduleTitle.emails": "E-maily",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Súhlas rodiča/poručníka",
    "label.photo_consent_given": "Účastník súhlasí s použitím jeho/jej profilovej fotky na propagáciu programu",
    "moduleTitle.authorising_contact": "Kontakt na autorizáciu",
    "label.assessment_with_role": "{role} – hodnotenie",
    "dashboard.type_of_awards": "Typ Miestneho centra",
    "moduleTitle.payment": "Platba",
    "states.in_progress": "Prebieha",
    "logs.no_logs": "Žiadne záznamy",
    "sidebar.my_office": "Moja kancelária",
    "label.assessor_report": "Správa Hodnotiteľa",
    "notifications.rp_has_been_signed_off": "Rezidenčný projekt bol schválený",
    "tabs.labels": "Štítky",
    "sidebar.payments": "Platby",
    "meta.profile_questions": "Profilové otázky",
    "label.fax": "Fax",
    "label.email_help_custom_link": "Vlastný odkaz, ak je nastavený.",
    "label.last_name": "Priezvisko",
    "organisation.manage_gop": "Spravovať globálneho autorizovaného prevádzkovateľa",
    "table.parental_consent": "Súhlas rodiča",
    "dashboard.participant_by_level": "Účastníci – podľa úrovne",
    "tabs.award_leaders": "Vedúci programu",
    "label.i_confirm_that_ive_witnessed": "Čestne potvrdzujem, že som videl záznamy v denníku účastníka pre nižšie uvedené aktivity",
    "table.lead_coordinator": "Hlavný koordinátor",
    "states.deleted": "Odstránené",
    "label.no_answers": "Bez odpovedí",
    "button.add": "Pridať",
    "label.exchequer_number": "Číslo účtu",
    "label.waiting": "Čaká",
    "label.email_help_person_full_name": "Plné meno osoby.",
    "tasks.return_registration": "Vrátiť registráciu",
    "notifications.state_aj_preparation_training_has_been_changed": "Stav prípravy a tréningu Dobrodružnej expedície bol zmenený.",
    "label.parent_approval": "Schválenie rodičom",
    "table.assessor_approve": "Schválenie hodnotiteľom",
    "errors.some_fields_requires_your_attention": "Niektoré položky vyžadujú pozornosť",
    "aj.qualifying_journey": "Kvalifikačná expedícia",
    "route.awards": "Ocenenia",
    "table.registration": "Registrácia",
    "pageTitle.assessors": "Hodnotitelia",
    "notifications.award_has_been_updated": "Aktivita bola aktualizovaná",
    "errors.must_be_one_of": "Musí byť jedna z týchto hodnôt: {enums} ",
    "pageTitle.logs": "Záznamy",
    "notifications.notifications.invitation_has_been_sent": "Pozvánka bola odoslaná",
    "route.national_offices": "Národné kancelárie",
    "notifications.training_has_been_updated": "Tréning bol aktualizovaný",
    "label.parent_last_name": "Priezvisko rodiča/poručníka",
    "table.leaders": "Vedúci",
    "states.award_level_complete": "Úroveň DofE dokončená",
    "button.reset": "Resetovať",
    "sidebar.my_award_unit": "Moje Miestne centrum",
    "pageTitle.all_aj_events": "Všetky dobrodružné expedície",
    "label.activity": "Aktivita",
    "moduleTitle.are_you_sure": "Ste si istí?",
    "route.gold_level": "Zlatá úroveň",
    "table.evidence": "Evidencia",
    "label.delivery_confirmed": "Dodanie potvrdené",
    "parentalConsent.as_the_parent": "Ako rodič/poručník dávam svoj súhlas na použitie obrázkov a fotografií na propagačné ciele programu DofE.",
    "label.awardMode.offline": "Papierový",
    "tasks.approve_registration": "Schváliť registráciu",
    "note.change_the_email_will_change": "Poznámka: zmenou e-mailu sa zmení aj e-mail migrovaného kontaktu",
    "notifications.participant_has_been_approved": "Účastník bol schválený",
    "label.reached_activity_limit": "V tejto oblasti aktivity sa dosiahol povolený limit aktivít. V rámci jednej oblasti sú povolené pre účastníka maximálne 3 aktivity.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Štítok bol aktualizovaný.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Príprava a tréning na dobrodružnú expedíciu boli odstránené",
    "pageTitle.settings": "Nastavenia",
    "participant.level_registration_date": "Dátum registrácie pre:  {value}",
    "notifications.question_has_been_removed": "Otázka sa odstránila",
    "label.email_help_award_leader_full_name": "Celé meno Vedúceho programu.",
    "sidebar.leaders": "Vedúci",
    "notifications.participants_have_been_transferred": "Účastníci boli prenesení",
    "tabs.assessors": "Hodnotitelia",
    "sidebar.dashboard": "Tabuľa",
    "pageTitle.independent_award_centers": "Nezávislé centrum programu",
    "label.search": "Hľadať",
    "moduleTitle.office_labels": "Štítok kancelárie",
    "label.note_from_participant": "Poznámka od účastníka",
    "errors.required_field": "Požadované pole",
    "tasks.approve_task": "Schváliť úlohu",
    "logs.edit_log": "Upraviť záznam",
    "table.state": "Stav",
    "moduleTitle.level_summary": "Sumár úrovne",
    "moduleTitle.guides": "Príručky",
    "modal.close": "Zavrieť",
    "label.parent_first_name": "Krstné meno rodiča/poručníka",
    "parentalConsent.i_understand_that_the_participant": "1. Beriem na vedomie, že účastník sa nemôže zúčastniť programu DofE, pokiaľ tento formulár (vrátane Súhlasu rodiča / zákonného zástupcu) nebol vyplnený a doručený príslušnému Miestnemu centru spolu s prípadným poplatkom, a následne nebol akceptovaný Miestnym centrom.",
    "tabs.award_units": "Miestne centrá",
    "table.hours": "Hodiny",
    "label.type": "Typ",
    "notifications.adventurous_journey_has_been_removed": "Dobrodružná expedícia bola odstránená",
    "label.aj_is_not_approved_yet": "Dobrodružná expedícia nie je zatiaľ schválená",
    "roles.authorizing_contact": "Autorizačný kontakt",
    "table.date_submitted_to_office_signoff": "Schválenie dátumu odoslania do Národnej kancelárie",
    "notifications.section_has_been_returned": "Oblasť bola vrátená",
    "table.created_by": "Vytvoril/-a",
    "route.user_guide_web_participant": "Užívateľská príručka - Účastník",
    "route.templates": "Šablóny",
    "states.awaiting_sign_off": "Schválenie Vedúcim programu",
    "table.phone": "Telefón",
    "label.parental_consent": "Rodičovský súhlas",
    "label.org_contact_will_be_deleted": "Vymazávate poslednú rolu, ktorú má kontakt v tejto organizácii. Chcete ponechať osobné informácie pripojené alebo chcete tento kontakt úplne vymazať z organizácie?",
    "route.bronze_level": "Bronzová úroveň",
    "label.invoice_currency": "Mena potvrdenia/faktúry",
    "button.new_label": "Nový štítok",
    "error.server_cannot_be_reached_at_the_moment": "Server momentálne nie je k dispozícii. Skúste neskôr prosím. Ak problém pretrváva, obráťte sa na náš tím.",
    "notifications.contact_has_been_created": "Kontakt bol vytvorený",
    "pageTitle.profile_questions": "Profilové otázky",
    "table.observation_files": "Súbory s pozorovaniami",
    "table.participants": "Účastníci",
    "tasks.no_evidence": "Nebol poskytnutý žiaden dôkaz",
    "button.edit": "Upraviť",
    "moduleTitle.leader": "Vedúci",
    "notifications.new_template_has_been_updated": "Nová šablóna bola aktualizovaná",
    "table.name": "Meno",
    "label.no_results": "Žiaden výsledok",
    "moduleTitle.documents": "Dokumenty",
    "button.invite": "Pozvať",
    "label.goal": "Cieľ",
    "pageTitle.nao_award_units": "Národná kancelária – Miestne centrá",
    "label.award_delete_participant_id": "ID účastníka",
    "errors.at_least_num_characters": "Musí obsahovať minimálne tento počet znakov: {length}",
    "label.email_help_note": "Vlastná poznámka, ak je nastavená.",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "Odstrániť rolu?",
    "label.total": "Spolu",
    "label.delete_participant_award_info": "Chystáte sa vymazať úroveň ocenenia. Táto akcia je nezvratná. Pravidlá:\na) účastník potrebuje viac ocenení\nb) hlavná aktivita sa vymaže v prípade, že to bolo vyžiadané na úrovni ocenenia, ktorú sa chystáte zmazať\nc) pokiaľ zostanú po vymazaní 2 ocenenia, tak sa hlavná aktivita nastaví na nižšej úrovni, a to len v prípade, že nie je v stave auth/completed/ceremony state.",
    "route.leaders": "Vedúci",
    "table.start_date": "Dátum začiatku",
    "moduleTitle.coordinators": "Koordinátori",
    "button.create": "Vytvoriť",
    "tabs.awards": "Ocenenia",
    "parentalConsent.form_has_been_sent": "Súhlas rodiča odoslaný.",
    "states.journey_approval": "Schválenie expedície",
    "pageTitle.reports": "Reporty",
    "table.journey_type": "Typ expedície",
    "label.yes": "Áno",
    "pageTitle.assessor_report": "Správa Hodnotiteľa",
    "label.organization": "Organizácia",
    "notifications.award_leader_has_been_updated": "Vedúci programu bol aktualizovaný",
    "moduleTitle.edit_role": "Upraviť rolu",
    "table.journey_activity": "Aktivita v rámci expedície",
    "label.location": "Miesto",
    "label.update_translations_error_item": "Aktualizácia prekladu zlyhala pre: {language}, kód: {localeCode}, projekt: {projectCode} pretože",
    "pageTitle.adventurous_journeys": "Dobrodružné expedície",
    "global.assessor": "Hodnotiteľ",
    "moduleTitle.profile_questions": "Profilové otázky",
    "activity.cannot_edit_activity_if_award_in_state": "Ak je pre DofE nastavený stav {state}, aktivita sa nedá upravovať",
    "moduleTitle.assessor_detail": "Podrobnosti o hodnotiteľovi",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Beriem na vedomie, že po prijatí Miestnym centrom do programu DofE účastník dostane Účastnícku knižku alebo získa prístup do Online Účastníckej knižky (ORB). Pred začiatkom aktivít týkajúcich sa programu DofE si účastník si prečíta podmienky programu DofE, uvedené v Účastníckej knižke alebo v ORB. Beriem na vedomie, že Miestne centrum má právo rozhodovať, či boli splnené podmienky programu DofE a teda či možno udeliť Bronzovú cenu, Striebornú cenu alebo Zlatú cenu. Beriem na vedomie, že Miestne centrum môže poskytovať účastníkom úrazové poistenie alebo poistenie zodpovednosti v obmedzenom rozsahu, po prijatí Miestnym centrom do programu DofE, avšak s tým, že samotný účastník a jeho rodič / zákonný zástupca sú zodpovední za zabezpečenie úrazového poistenia pre seba.  ",
    "notifications.award_has_been_returned": "DofE bolo vrátené",
    "label.code_of_conduct": "",
    "button.new_contact": "Nový kontakt",
    "tabs.payments": "Platby",
    "roles.naa_oa_staff": "Zamestnanci OA NAA",
    "label.switch_organisation_hint": "Toto dialógové okno môžete kedykoľvek otvoriť výberom možnosti Prepnúť organizáciu v ponuke v pravom hornom rohu",
    "label.expiration_date": "Dátum ukončenia platnosti",
    "tabs.participants": "Účastníci",
    "table.practice": "Cvičná",
    "notifications.one_activity_has_to_remain": "Jedna aktivita v oblasti musí ostať neodstránená",
    "label.qualifications": "Kvalifikácie",
    "states.organization_approval": "Schválenie organizáciou",
    "errors.must_be_an_integer": "Musí byť celé číslo",
    "participant.send_confirmation_email_again_question": "Odoslať znova potvrdzujúci email?",
    "button.dismiss": "Zavrieť",
    "table.advice": "Oznámenie",
    "label.years_of_working_experience": "Pracovná skúsenosť (v rokoch)",
    "notifications.search_failed": "Počas vyhľadávania sa vyskytla chyba. Skúste neskôr prosím.",
    "notifications.changes_have_been_saved": "Zmeny boli uložené",
    "moduleTitle.resend_parental_consent_link": "Znova odoslať prepojenie na rodičovský súhlas?",
    "label.activity_type": "Typ aktivity",
    "label.change_award": "Zmeniť úroveň DofE",
    "label.email": "E-mail",
    "button.remove": "Odstrániť",
    "button.download": "Stiahnuť",
    "label.vat_treatment": "Nastavenie DPH",
    "pageTitle.aj_template_new": "Šablóna novej dobrodružnej expedície",
    "table.per_page": "na stranu",
    "notifications.translations_has_been_updated": "Preklady boli aktualizované",
    "notification.award_mode_has_been_updated": "Režim ocenenia bol upravený",
    "tasks.revise_item": "Revidovať položku",
    "button.resend_parental_consent": "Znova odoslať rodičovský súhlas",
    "table.weeks_completed_required": "Dokončené/Požadované týždne",
    "label.last_modified": "Naposledy upravené",
    "table.major": "Hlavná",
    "label.vat_number": "DIČ",
    "errors.passwords_dont_match": "Heslá sa nezhodujú",
    "table.country": "Krajina",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Otázka sa aktualizovala",
    "table.participant_name": "Meno účastníka",
    "label.registration_approval_date": "Dátum potvrdenia registrácie",
    "notifications.auth_code_is_no_longer_valid": "Autorizačný kód už nie je platný",
    "errors.must_be_no_more_than": "Nesmie obsahovať viac ako tento počet znakov: {max}",
    "notifications.event_has_been_rejected": "Udalosť bola vrátená",
    "tabs.customizations": "Prispôsobenia",
    "label.name_organization": "Názov",
    "button.add_log": "Pridať záznam",
    "moduleTitle.invite_assessor": "Pozvať hodnotiteľa",
    "label.resend_confirmation_email": "Znova odoslať potvrdzovací e-mail",
    "text.all_participants_will_be_transfered": "Všetci účastníci budú prenesení k novému Vedúcemu DofE",
    "label.repeat_email": "Znova zadať e-mail",
    "errors.email_or_phone_required": "Je nevyhnutné zadať email alebo telefón",
    "notifications.role_has_been_updated": "Rola bola aktualizovaná",
    "roles.if_staff_stat_user": "IF Statistical User",
    "participant.delete_account": "Odstrániť konto",
    "moduleTitle.would_you_like_to_remove_this_log": "Chcete tento záznam zmazať?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "Napísať nový email",
    "table.journey_category": "Kategória expedície",
    "sidebar.manual_data_import": "Manuálny import údajov",
    "label.created_after_date": "Vytvorené po",
    "route.my_organization": "Moja organizácia",
    "button.show_list": "Zobraziť zoznam",
    "label.leaders": "Vedúci",
    "notifications.log_has_been_modified": "Záznam bol upravený",
    "button.upload_file": "Načítať súbor",
    "moduleTitle.which_section_do_you_want_to": "Pre ktorú oblasť chcete obnoviť jej stav na možnosť Spracováva sa?",
    "tabs.bronze_level": "Bronzová úroveň",
    "notifications.participants_have_been_saved": "Údaje účastníkov boli uložené",
    "pageTitle.aj_template_detail": "Dobrodružná expedícia",
    "label.parent_email": "E-mail rodiča/poručníka",
    "map.appr_location": "Približná adresa:",
    "notifications.log_has_been_removed": "Záznam bol odstránený",
    "notifications.label_has_been_assigned": "Štítok bol priradený.",
    "pageTitle.tasks_undelivered_emails": "Nedoručené emaily",
    "button.stay": "Ponechať",
    "table.previous_level": "Predchádzajúca úroveň",
    "label.award_start_date": "Dátum spustenia DofE",
    "assessor_report.returned_to_participant": "Vrátené účastníkovi",
    "pageTitle.tasks_assessors_registration": "Registrácia hodnotiteľa",
    "aj.cannot_modify_award": "Po priradení účastníka nie je možné upravovať úroveň DofE",
    "moduleTitle.lost_internet_connection": "Pravdepodobne ste stratili svoje internetové pripojenie",
    "states.ceremony": "Ceremónia",
    "participant.reactivate_account": "Znova aktivovať konto",
    "label.birthdate": "Dátum narodenia",
    "pageTitle.assessment_send_successfully": "Hodnotenie bolo odoslané",
    "states.assessor_approval": "Schválenie Hodnotiteľom",
    "award.change_award_level": "Zmeniť úroveň DofE",
    "label.url_no_longer_valid": "Táto URL adresa už nie je platná.",
    "button.update": "Aktualizovať",
    "label.secondary_email": "Sekundárny e-mail",
    "button.role_edit": "Upraviť",
    "table.award_leader": "Vedúci programu",
    "label.level": "Úroveň",
    "tasks.evidence": "Evidencia",
    "notifications.participant_is_already_in_list": "Účastník sa na zozname už nachádza",
    "button.clear": "Vymazať",
    "label.allow_log_after_25_yoa": "Povoliť pridávanie záznamov po dovŕšení 25. roku",
    "states.setup": "Nastaviť",
    "table.activity": "Aktivita",
    "label.copy_to_clipboard": "{text} bol skopírovaný do schránky.",
    "route.award_units": "Miestne centrá",
    "button.upload_photo": "Nahrať obrázok",
    "table.hours_completed_required": "Dokončené/požadované hodiny",
    "table.first_name": "Krstné meno",
    "notifications.adventurous_journey_has_been_returned": "Dobrodružná expedícia bola vrátená",
    "pageTitle.national_offices": "Národné kancelárie",
    "notifications.you_have_been_logged_in": "Prihlásenie do systému bolo úspešné",
    "logs.offline": "Offline",
    "moduleTitle.add_role": "Pridať rolu",
    "label.user_app_guide_participant": "Užívateľská príručka - Účastník",
    "notifications.file_has_been_removed": "Súbor bol odstránený",
    "label.send_message": "Odoslať správu",
    "button.select": "Vybrať",
    "label.reason_of_deletion": "Dôvod vymazania",
    "label.user_guide": "Užívateľská príručka",
    "pageTitle.nao_participants": "Národná kancelária – Účastníci",
    "tabs.sub_operating_partners": "Autorizovaní prevádzkovatelia na nižšej úrovni",
    "table.uploaded_by": "Nahral/a",
    "tasks.approve_item": "Schváliť položku",
    "tasks.restore_participant_registration": "Obnoviť registráciu účastníka?",
    "label.awardMode.hybrid": "Hybridný",
    "table.first_activity_started": "Začiatok prvej aktivity",
    "moduleTitle.dates": "Dátumy",
    "table.no_results": "Žiadne výsledky",
    "states.registration_approval": "Schválenie registrácie",
    "table.breakdown_of_hours": "Rozdelenie hodín",
    "pageTitle.tasks_registration": "Registrácia účastníka",
    "button.create_new": "Vytvoriť nové",
    "sidebar.todolist": "Zoznam úloh",
    "label.active_participants": "Aktívni účastníci",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "Vrátiť úlohu",
    "organisation.change_organisation_state": "Zmeniť stav organizácie",
    "moduleTitle.roles": "Role",
    "label.no_config_key_available": "Kľúč konfigurácie nie je dostupný pre túto oblasť",
    "placeholder.selectLanguage": "Vybrať jazyk",
    "states.office_signoff": "Schválene Národnou kanceláriou",
    "notifications.translations_has_been_updated.failure": "Aktualizácia prekladu zlyhala",
    "logs.minute": "minúta",
    "label.last_activity": "Posledná aktivita",
    "sidebar.user_guide": "Užívateľská príručka",
    "label.trained_award_leader": "vyškolený Vedúci programu",
    "table.progress": "Postup",
    "table.suboperating_authorities": "Autorizovaní prevádzkovatelia na nižšej úrovni",
    "activity.cannot_edit_activity_offline": "Tento účastník pracuje v papierovom režime.<br><br>\nNemôžete upravovať aktivitu, dobrodružnú expedíciu alebo rezidenčný projekt ak je účastník v čiastočne papierovom režime.",
    "label.user_does_not_have_permissions": "Používateľ <strong>{user}</strong> nemá povolenie na zobrazenie tohto obsahu.",
    "notifications.assessor_has_been_approved": "Hodnotiteľ bol schválený",
    "route.activity_approval": "Schválenie aktivity",
    "moduleTitle.role": "Rola",
    "button.run": "Spustiť",
    "label.to": "Komu",
    "notifications.file_has_been_updated": "Súbor bol aktualizovaný",
    "moduleTitle.edit_coordinator": "Upraviť koordinátora",
    "notifications.authorization_code_is_no_longer_valid": "Autorizačný kód už nie je platný",
    "button.reject": "Zamietnuť",
    "label.label.participant_status": "Stav účastníka",
    "award.gold_level": "Zlatá úroveň",
    "sidebar.variables": "Premenné",
    "parentalConsent.checkbox_copy": "Potvrdzujem, že som rodičom/poručníkom účastníka {firstName} {lastName}. Súhlasím s tým, aby sa zúčastnil/-a programu DofE v organizácii {organisationName} pod dohľadom vyškoleného Vedúceho programu. Prečítal/-a som si, rozumiem a súhlasím s požiadavkami a podmienkami účasti v programe DofE tak, ako sú uvedené vyššie a na webovej lokalite poskytovateľa DofE.",
    "button.go_to_dashboard": "Prejsť na tabuľu",
    "button.add_option": "Pridať možnosť",
    "label.is_completed": "Je dokončené",
    "pageTitle.award_units": "Miestne centrá",
    "states.completed": "Dokončené",
    "button.adventurous_journey_template_settings": "Nastavenie šablóny dobrodružnej expedície",
    "label.system_rights": "Systémové práva",
    "label.assessor_assesstment_award_start_date": "Dátum začiatku vyhodnotenia úrovne",
    "label.update_translation_question": "Preklady vo všetkých existujúcich jazykoch boli aktualizované pre všetky vybrané projekty",
    "button.login": "Prihlásenie",
    "label.name_of_the_unit": "Názov centra",
    "button.send": "Odoslať",
    "award.ajs": "Dobrodružné expedície",
    "meta.payments_expired": "Platby – exspirované",
    "label.age": "Vek",
    "notifications.payment_info_updated": "Informácie o platbe sa aktualizovali",
    "table.is_completed": "Dokončené",
    "table.invited_by": "Pozval/-a",
    "route.files": "Súbory",
    "route.assessors": "Hodnotitelia",
    "info.aj_supervisor_is_mandatory": "Pre cvičnú expedíciu dostane žiadosť o hodnotenie Školiteľ expedície a pre Kvalifikačnú expedíciu dostane žiadosť o hodnotenie Hodnotiteľ expedície.",
    "pageTitle.my_participants": "Moji účastníci",
    "label.change_leader_status": "Zmeniť stav vedúceho",
    "moduleTitle.parent_consent_form": "Formulár súhlasu rodiča/poručníka",
    "notifications.authorization_contact_has_been_set": "Kontakt na autorizáciu bol schválený",
    "button.close": "Zavrieť",
    "label.independent_country": "Nezávislá krajina",
    "notifications.aj_preparation_training_has_been_returned": "Príprava a tréning na dobrodružnú expedíciu boli vrátené",
    "route.history_log": "Záznam histórie",
    "participant.account_settings": "Nastavenia konta",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} pretože",
    "label.orb_account": "ORB konto",
    "notifications.file_url_is_not_specified_in_configuration": "URL súboru nie je uvedené v konfigurácii",
    "notifications.award_unit_has_been_removed": "Odstránilo sa miestne centrum/rada DofE",
    "table.parent": "Rodičovská organizácia",
    "label.mode_of_transport": "Spôsob presunu",
    "label.parental_consent_email_info": "Nezabudnite skontrolovať e-mail rodiča a manuálne odoslať súhlas z obrazovky detail úrovne DofE.",
    "label.current_award": "Aktuálna úroveň DofE",
    "table.action": "Akcia",
    "pageTitle.suboperating_authorities": "Autorizovaní prevádzkovatelia na nižšej úrovni",
    "notifications.award_leader_has_been_assigned": "Vedúci programu bol priradený",
    "tabs.sign_offs_locally": "Lokálne schválenia",
    "Activity log has been restored": "denník.upozornení_sa_obnovil",
    "sidebar.naos": "Národné kancelárie DofE",
    "tabs.aj_templates": "Šablóny dobrodružnej expedície",
    "notifications.logging_out": "Prebieha odhlásenie...",
    "label.update_label": "Uprav štítok",
    "button.organisation_settings": "Nastavenie organizácie",
    "tabs.independent_award_centers": "Nezávislé centrá DofE",
    "label.current": "Aktuálne",
    "table.location": "Miesto",
    "button.search": "Hľadať",
    "notifications.aj_preparation_training_has_been_approved": "Príprava a tréning na dobrodružnú expedíciu boli schválené",
    "route.participants": "Účastníci",
    "label.other_location_information": "Ďalšie informácie o mieste",
    "label.number_of_records": "Počet záznamov",
    "translationsManagement.infoLabel": "Táto funkcia umožňuje aktualizovať preklady z programu POEditor",
    "parentalConsent.i_consent_to_pay_all": "5. Súhlasím s tým, že zaplatím všetky poplatky a náklady súvisiace s pomocou týchto lekárov, zdravotných sestier alebo pobytom v nemocnici, ktoré vznikli účastníkovi následkom takého úrazu, zranenia, choroby alebo straty, ktoré utrpel účastník v rámci účasti na alebo cestou do a z akýchkoľvek aktivít alebo úloh týkajúcich sa programu DofE.",
    "label.nationality": "Národnosť",
    "states.approval": "Schválenie",
    "notifications.something_went_wrong": "Vyskytla sa chyba",
    "aj.practice": "Cvičná",
    "label.addressLine2": "Druhý riadok adresy",
    "label.please_leave_a_note": "Zanechajte, prosím, svoju poznámku",
    "placeholder.select": "Vybrať",
    "label.observations": "Pozorovania",
    "label.aim": "Cieľ",
    "label.addressLine1": "Prvý riadok adresy",
    "roles.aj_instructor": "Inštruktor pre dobrodružnú expedíciu",
    "meta.payments_waiting": "Platby – čakajúce",
    "label.award_to_delete": "Vymazať úroveň ocenenia",
    "label.category": "Kategória",
    "roles.instructor": "Inštruktor",
    "moduleTitle.remove_customization_and_reset": "Odstrániť prispôsobenie a vynulovať hodnoty?",
    "notifications.participant_registration_has_been_restored": "Registrácia účastníka bola obnovená",
    "organisation.change_award_unit_mode": "Zmeniť režim organizácie",
    "table.organization_type": "Typ organizácie",
    "notifications.participant_has_been_deleted": "Účastník bol odstránený",
    "label.language_settings": "Nastavenie jazyka",
    "notifications.event_has_been_approved": "Udalosť bola schválená",
    "label.password": "Heslo",
    "label.text": "Text",
    "table.observations": "Pozorovania",
    "notifications.participant_has_been_created": "Účastník bol vytvorený",
    "table.note_for_al": "Poznámka pre Vedúceho programu",
    "label.payment_confirmed": "Platba potvrdená",
    "label.previous_completed_award_level": "Predchádzajúca úroveň (nie ORB)",
    "pageTitle.new_aj_event": "Nová dobrodružná expedícia",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Vzťah k účastníkovi",
    "award.physical_recreation": "Športová aktivita",
    "contact.collect_emails": "Vyselektovať adresy pre poslanie emailu",
    "moduleTitle.assessor_report_reject": "Odmietnutie správy hodnotiteľa",
    "label.supervisor_report": "Správa školiteľa",
    "table.role": "Rola",
    "route.user_guide_web_nao": "Užívateľská príručka - Národná kancelária",
    "label.page_not_found": "404 - Stránka nenájdená",
    "table.labels": "Štítky",
    "notifications.file_has_been_uploaded": "Súbor bol nahraný",
    "moduleTitle.address": "Adresa",
    "moduleTitle.lead_coordinator": "Hlavný koordinátor",
    "pageTitle.login": "Prihlásenie",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "Chcete vymazať túto registráciu?",
    "notifications.rp_has_been_setup": "Rezidenčný projekt bol nastavený",
    "moduleTitle.award_unit": "Miestne centrum",
    "button.remove_file": "Odstrániť súbor",
    "moduleTitle.billing_address": "Fakturačná adresa",
    "pageTitle.my_aj_events": "Moje dobrodružné expedície",
    "route.tasks": "Úlohy",
    "button.confirm": "Potvrdiť",
    "label.national_award_authority": "Národná kancelária programu DofE",
    "label.independent_award_centre": "Nezávislé centrum programu",
    "award.generate_award_report": "Vygenerovať správu",
    "route.my_region_office_customization": "Moja regionálna kancelária – úprava",
    "label.email_help_aj_category": "Kategória Dobrodružnej expedície.",
    "label.your_report_has_been_rejected": "Vrátili ste hodnotenie bez schválenia",
    "notifications.password_change_request_has_been_sent": "Žiadosť o zmenu hesla bola odoslaná",
    "tabs.detail": "Podrobnosti",
    "participant.change_participant_status": "Zmeniť stav účastníka",
    "table.key": "Kľúč",
    "label.find_address": "Hľadať adresu",
    "notifications.assessor_has_been_rejected": "Revidovali sa údaje hodnotiteľa",
    "label.transfer_participants": "Preniesť účastníkov",
    "button.continue_to_payment_gateway": "Pokračovať do platobnej brány",
    "notifications.participant_registration_has_been_removed": "Registrácia účastníka bola odstránená",
    "moduleTitle.page_not_found": "404 - Stránka nenájdená",
    "route.adventurous_journeys": "Dobrodružné expedície",
    "states.registration_assessment": "Hodnotenie registrácie",
    "heading.change_award_unit_mode": "Zmeniť režim Miestneho centra",
    "label.user_guide_web_nao": "Užívateľská príručka - Národná kancelária",
    "tabs.silver_level": "Strieborná úroveň",
    "table.paid_by": "Uhradil/-a",
    "label.your_report_has_been_successfully_sent": "Vaša správa sa úspešne odoslala.",
    "sidebar.my_organization": "Moja organizácia",
    "pageTitle.participants": "Účastníci",
    "notifications.preparation_training_has_been_updated": "Príprava a tréning boli aktualizované",
    "moduleTitle.server_is_unreachable": "Server je nedostupný",
    "label.last_activity_date": "Dátum poslednej aktivity",
    "award.bronze_level": "Bronzová úroveň",
    "moduleTitle.award_units": "Miestne centrá",
    "table.completed": "Dokončené",
    "moduleTitle.revise_message": "Správa k vráteniu",
    "table.lastUsed": "Naposledy použité",
    "award.bronze_to_gold_level": "Z bronzovej na zlatú úroveň",
    "button.change_password": "Zmeniť heslo",
    "label.nao_price": "Príspevok pre Národnú kanceláriu",
    "label.payment_state": "Stav platby",
    "label.wwc_expired": "Vypršala platnosť WWC",
    "label.award_office_signoff_date": "Dátum schválenia Národnou kanceláriou",
    "label.award_unit": "Miestne centrum",
    "award.gold_level_short": "Zlatá",
    "moduleTitle.other_info": "Ďalšie informácie",
    "table.note": "Poznámka",
    "label.search_by_email_first_or_last": "Hľadať podľa e-mailu, krstného mena alebo priezviska",
    "tabs.history": "História",
    "notifications.label_has_been_created": "Štítok bol vytvorený.",
    "tabs.unassigned_participants": "Nepriradení účastníci",
    "table.main_award_leader": "Hlavný Vedúci programu",
    "parentalConsent.i_as_the_parent": "3. Beriem na vedomie, že niektoré aktivity sa považujú za vysoko rizikové a že na tieto vysoko rizikové aktivity sa nevzťahuje poistenie zabezpečené Miestnym centrom. Beriem na vedomie, že zodpovednosť za všetky riziká súvisiace s účasťou účastníka v programe DofE znáša výlučne samotný účastník.",
    "label.state": "Stav",
    "notifications.award_leader_has_been_removed": "Vedúci projektu bol odstránený",
    "tabs.organization_detail": "Podrobnosti o organizácii",
    "table.operating_authorities": "Autorizovaní prevádzkovatelia",
    "label.available_labels": "Dostupné štítky",
    "modal.select": "Vybrať",
    "tabs.expired_payments": "Expirované platby",
    "moduleTitle.note_for_al": "Poznámka pre Vedúceho programu",
    "moduleTitle.confirm": "Potvrdiť",
    "notification.new_activity_added": "Pridala sa nová aktivita",
    "notifications.award_leader_has_been_moved": "Vedúci programu bol presunutý",
    "label.award_mode": "Režim ocenenia",
    "label.phone": "Telefón",
    "notifications.organization_has_been_updated": "Údaje organizácie boli aktualizované",
    "moduleTitle.assessor": "Hodnotiteľ",
    "label.bulk_action_confirmation": "Potvrdenie hromadnej zmeny",
    "table.parent_approval": "Schválenie rodičom",
    "label.date_of_delivery": "Dátum dodania",
    "sidebar.assessors": "Hodnotitelia",
    "label.journey_activity": "Aktivita v rámci expedície",
    "award.inactive_award": "Deaktivovať DofE",
    "label.end_date": "Dátum dokončenia",
    "label.orb_testing": "ORB testovanie",
    "label.no_activities": "Žiadne aktivity",
    "moduleTitle.please_confirm": "Potvrďte, prosím",
    "button.login_with_another_account": "Prihlásiť sa s iným kontom",
    "tasks.reject_registration": "Zamietnuť registráciu",
    "label.submitted_after_date": "Odoslané po dátume",
    "label.update_translations_successful": "{count} položiek úspešne zmenených.",
    "button.assign_leader": "Priradiť Vedúceho",
    "table.already_running": "Už prebieha",
    "label.no": "Nie",
    "label.count_items_selected": "Počet vybratých položiek: {count}",
    "label.secondary_phone_number": "Sekundárne telefónne číslo",
    "label.my_experience": "Moje skúsenosti",
    "notifications.adventurous_journey_has_been_approved": "Dobrodružná expedícia bola schválená",
    "pageTitle.mro_detail": "Moja oblastná kancelária – Podrobnosti",
    "moduleTitle.nao_specific_info": "Špecifické informácie o národnej kancelárii",
    "label.preparing_document_for_import": "Príprava dokumentu na import",
    "tasks.observations": "Pozorovania",
    "notifications.confirmation_email_has_been_sent": "Potvrdzujúci email bol odoslaný",
    "button.restore": "Obnoviť",
    "label.importing_file": "Import súboru",
    "label.or_dont_agree": "Nesúhlasíte? Môžete",
    "moduleTitle.award_leader": "Vedúci programu",
    "label.me": "(ja)",
    "tabs.sub_global_operating_partners": "Globálni autorizovaní prevádzkovatelia na nižšej úrovni",
    "button.export_table": "Exportovať tabuľku",
    "organisation.move_award_unit": "Presunúť Miestne centrum",
    "label.file_category": "",
    "notifications.connecting_to_server": "Pripája sa na server...",
    "parentalConsent.i_understand_that_a_and_b": "11. Beriem na vedomie, že: <br /> a. účastník nesmie riadiť motorové vozidlo ani prepravovať iných účastníkov zúčastnených na aktivitách týkajúcich sa Programu, pokiaľ nie je držiteľom príslušného a platného vodičského oprávnenia; a <br /> b. účastník nesmie byť prepravovaný inou osobou, ktorá nie je zapojená do alebo pomáha s organizáciou programu DofE pre účely účasti na programu DofE, pokiaľ táto osoba nie je držiteľom príslušného a platného vodičského oprávnenia.",
    "table.reason": "Dôvod",
    "pageTitle.contacts": "Kontakty",
    "states.award_leader_approval": "Schválenie Vedúcim programu",
    "meta.payments": "Platby",
    "label.suboperating_authority": "Kancelária na nižšej úrovni",
    "route.my_region_office": "Moja oblastná kancelária",
    "states.registration_not_approved": "Registrácia neschválená",
    "label.direct_entrant": "Priamy účastník",
    "tabs.all_participants": "Všetci účastníci",
    "tabs.payment": "Platba",
    "label.email_help_activity_name": "Názov aktivity.",
    "title.update_report": "Nahrať správu",
    "label.repeat_new_password": "Znova nové heslo",
    "label.other_roles": "ORB profil",
    "logs.hours": "hod.",
    "notifications.spreadsheet_has_been_imported_successfully": "Tabuľka bola úspešne importovaná",
    "label.bulk_action_question": "Vykonať hromadnú zmenu u {count} položiek?",
    "moduleTitle.personal_details": "Osobné detaily",
    "label.bulk_action_emailing": "Emailové adresy vybraných účastníkov",
    "route.my_events": "Moje udalosti",
    "button.delete_award": "Vymazať ocenenie",
    "errors.include_both_lower_and_upper_case": "Súčasťou musia byť malé a veľké písmená",
    "tabs.removed_participant_registrations": "Odstránené registrácie účastníka",
    "sidebar.mynao": "Moja Národná kancelária DofE",
    "tabs.office_details": "Podrobnosti o kancelárii",
    "label.major": "Hlavná",
    "tabs.documents": "Dokumenty",
    "label.new_password": "Nové heslo",
    "sidebar.adventure_journey": "Dobrodružná expedícia",
    "pageTitle.customizations": "Prispôsobenia",
    "moduleTitle.assessor_report": "Správa od: {role}",
    "label.registration_date": "Dátum registrácie",
    "notifications.training_has_been_added": "Tréning bol pridaný",
    "aj.qualifying": "Kvalifikačná",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Boli ste odhlásení, lebo aktuálna relácia sa ukončila",
    "award.service": "Dobrovoľníctvo",
    "notifications.rp_state_has_been_changed": "Rezidenčný projekt bol zmenený",
    "label.ctest_access": "Prístup na testovaciu stránku",
    "table.created": "Vytvorené",
    "tasks.revise_task": "Revidovať úlohu",
    "button.assign": "Priradiť",
    "button.return": "Vrátiť",
    "table.status": "Stav",
    "button.restore_activity": "Obnoviť aktivitu",
    "tabs.new_aj_event": "Nová dobrodružná expedícia",
    "roles.if_staff_viewer": "Používateľ s právomocami na zobrazenie – zamestnanec nadácie DofE",
    "notifications.new_template_has_been_created": "Bola vytvorená nová šablóna",
    "global.something_went_wrong": "Vyskytla sa chyba",
    "table.expire_day": "Deň ukončenia platnosti",
    "tabs.history_log": "Záznam histórie",
    "label.form_of_payment": "Spôsob úhrady",
    "button.add_training": "Pridať tréning",
    "label.par_reg_cust_note": "Táto karta vám umožňuje prispôsobiť polia, ktoré sa zobrazujú pri registrácii účastníka a ovplyvniť tak množstvo údajov, ktoré zhromažďujete. Ak si želáte vykonať zmeny, obráťte sa na svoju regionálnu kanceláriu - prístup k týmto zmenám má iba administrátor IAF Systému.",
    "label.my_qualification": "Moja kvalifikácia",
    "button.add_new_profile_question": "Pridať otázku týkajúcu sa nového profilu",
    "table.operating_authority": "Autorizovaný prevádzkovateľ",
    "table.aim": "Cieľ",
    "table.awards": "Ocenenia",
    "participant.deactivate_account": "Deaktivovať konto",
    "table.organization_name": "Organizácia",
    "label.email_help_award_leader_first_name": "Krstné meno Vedúceho programu.",
    "table.date": "Dátum",
    "tasks.would_you_like_to_delete": "Chcete tohto účastníka odstrániť?",
    "notifications.configuration_value_has_been_updated": "Aktualizovala sa hodnota konfigurácie",
    "ajTemplates.fill_from_template": "Vyplniť zo šablóny",
    "contact.send_test_email": "Odoslať testovací e-mail",
    "moduleTitle.aj_preparation_and_training": "Príprava a tréning na dobrodružnú expedíciu",
    "label.ce_be": "Upraviteľný text emailu (preklady emailov)",
    "button.notify_participant": "Späť na účastníka",
    "label.parent_phone": "Telefónne číslo rodiča/poručníka",
    "label.nao_regulations": "",
    "award.skills": "Rozvoj talentu",
    "label.reject_application": "túto aplikáciu odmietnuť.",
    "leader.delete_account": "Odstrániť účet",
    "table.assign": "Priradiť",
    "roles.aj_supervisor": "Školiteľ dobrodružnej expedície",
    "label.logout": "Odhlásenie",
    "moduleTitle.award_leader_edit": "Upraviť údaje Vedúceho projektu",
    "moduleTitle.training": "Tréning",
    "notifications.coordinator_has_been_removed": "Koordinátor bol odstránený",
    "tabs.operating_partners": "Autorizovaní prevádzkovatelia",
    "moduleTitle.main_award_leader": "Hlavný vedúci programu/koordinátor",
    "label.bulk_action_successful": "Počet položiek, ktoré boli úspešne upravené: {count}.",
    "tasks.clear_email_revision": "Vymazať revíziu e-mailu",
    "table.preparation": "Príprava",
    "table.delete": "Odstrániť",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Reporty",
    "pageTitle.sub_global_operating_partners": "Globálni autorizovaní prevádzkovatelia na nižšej úrovni",
    "label.is_major_activity_confirmation": "Účastník už má hlavnú aktivitu splnenú na inej úrovni. Chcete pridať ďalšiu?",
    "pageTitle.operating_authorities": "Autorizovaní prevádzkovatelia",
    "label.delete_participant_award_modal_question_detail": "Ste si istý, že chcete vymazať {awardLevel} účastníka {participantId}.",
    "label.confirmed": "Schválené",
    "notifications.invitation_has_been_sent": "Pozvánka bola odoslaná",
    "pageTitle.independent_countries": "Nezávislé krajiny",
    "label.assessors_email": "E-mail hodnotiteľa",
    "tasks.approve_assessor_registration": "Schváliť registráciu hodnotiteľa",
    "table.award_duration": "Trvanie DofE",
    "notifications.organization_has_been_moved": "Organizácia bola presunutá",
    "pageTitle.nao_payment": "Národná kancelária – Platba",
    "participant.history_log": "Záznam histórie",
    "label.rejected_with_note": "",
    "label.already_running": "Už prebieha",
    "button.continue": "Pokračovať",
    "award.no_data_to_show": "Žiadne údaje na zobrazenie",
    "participant.send_email_invitation_again_question": "Znova odoslať e-mailovú pozvánku?",
    "label.reason_for_changing_assessor": "Dôvod na zmenu hodnotiteľa",
    "button.delete": "Odstrániť",
    "moduleTitle.requirements_and_conditions": "Požiadavky a podmienky",
    "roles.leader": "Vedúci",
    "label.if_download_doesnt": "Ak sa sťahovanie nespustí automaticky, skontrolujte nastavenia vyskakovacieho okna v prehliadači",
    "dashboard.your_todo_list": "Tvoj zoznam úloh",
    "notifications.award_unit_has_been_returned": "Miestne centrum bolo vrátené",
    "moduleTitle.participant_activities": "Aktivity účastníka",
    "errors.qualification_or_experience_required": "Kvalifikácia alebo skúsenosť je vyžadovaná",
    "label.active_leaders": "Aktívni Vedúci",
    "aj.preparation": "Príprava",
    "button.change_state": "Zmeniť stav",
    "label.current_password": "Aktuálne heslo",
    "pageTitle.global_operating_partners": "Globálni autorizovaní prevádzkovatelia",
    "moduleTitle.contact_settings": "Nastavenie kontaktu",
    "button.remove_photo": "Odstrániť fotografiu",
    "notifications.activity_has_been_setup": "Aktivita bola nastavená",
    "errors.must_be_more_than": "Musí obsahovať viac ako tento počet znakov: {limit}",
    "table.goal": "Cieľ",
    "notifications.coordinator_has_been_set": "Koordinátor bol nastavený",
    "label.cc": "Kópia",
    "label.duration": "Trvanie",
    "table.actions": "Akcie",
    "participant.send_email_invitation_again": "Znova odoslať e-mailovú pozvánku?",
    "moduleTitle.would_you_like_to_remove_participant": "Chcete odstrániť účastníka #{value}",
    "parentalConsent.i_authorise_employees": "4. Týmto oprávňujem zamestnancov, predstaviteľov a/alebo zástupcov Miestneho centra a iných osôb zúčastnených na programe DofE, zapojených do programu DofE alebo organizujúcich program DofE, aby v prípade akéhokoľvek úrazu, zranenia, choroby alebo straty, ktoré utrpí účastník v rámci účasti na alebo cestou do a z akýchkoľvek aktivít alebo úloh týkajúcich sa programu DofE, získali pre účastníka akúkoľvek potrebnú zdravotnú starostlivosť alebo liečenie, vrátane, avšak nie výlučne, pomoci lekárov, zdravotných sestier alebo pobytu v nemocnici.",
    "button.reload_page": "Znova načítať stránku",
    "moduleTitle.update_translations": "Aktualizovať preklady projektu",
    "label.report_description": "",
    "table.email": "E-mail",
    "label.new_goal": "Nový cieľ",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Neplatná e-mailová adresa",
    "pageTitle.new_contact": "Nový kontakt",
    "sidebar.gops": "",
    "button.manage_participants": "Spravovať účastníkov",
    "errors.invalid_phone_format": "Neplatné telefónne číslo",
    "notifications.login_details_have_been_changed": "Prihlasovacie údaje sa zmenili",
    "moduleTitle.participant_logs": "Denníky účastníka",
    "label.save": "Uložiť",
    "label.frequently_asked_questions": "Najčastejšie otázky",
    "label.city": "Mesto",
    "notifications.configuration_value_has_been_reset": "Konfiguračná hodnota bola vynulovaná",
    "states.office_sign_off": "Schválenie Národnou kanceláriou",
    "button.save": "Uložiť",
    "button.import_data_from_selected_file": "Importovať údaje z vybraného súboru",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Beriem na vedomie, že účastník nesmie začať žiadnu z častí programu DofE, dokým sa ja sám nepresvedčím o tom, že ktorýkoľvek dobrovoľník navrhnutý účastníkom, ktorý nie je zamestnancom Miestneho centra, je dostatočne skúsený a/alebo kvalifikovaný na vedenie / dohľad / vyhodnotenie príslušnej časti programu DofE; a dokým všetci príslušní dobrovoľníci nevyplnia a nevrátia požadované dokumenty voči Miestnemu centru.",
    "pageTitle.apiKeys": "Kľúče API",
    "label.international_region": "Medzinárodný región",
    "tabs.levels": "Úrovne",
    "tabs.additional_files": "Dodatočné súbory",
    "label.continuation_level": "Úroveň pokračovania",
    "table.adventurous_journey_detail": "Podrobnosti dobrodružnej expedície",
    "button.set": "Nastaviť",
    "label.i_certify_that_as_the_assessor": "Ako {role} pre túto aktivitu potvrdzujem, že uvedený účastník splnil požiadavky a taktiež dosiahol svoj cieľ.",
    "table.coordinator": "Koordinátor",
    "participant.send_confirmation_email_again": "Odoslať znova potvrdzujúci email?",
    "table.report": "Správa",
    "label.update_translations_results": "Aktualizovať výsledky prekladov",
    "table.observation_note": "Poznámka o pozorovaní",
    "label.view_more": "Zobraziť viac",
    "notifications.payment_link_has_been_reset": "Resetovalo sa prepojenie na platbu",
    "table.type": "Typ",
    "moduleTitle.updateConfigurationKey": "Aktualizovať kľúč konfigurácie",
    "sidebar.independent_award_centers": "Nezávislé centrá programu",
    "table.activity_type": "Typ aktivity",
    "label.awardMode.online": "Online v ORB",
    "table.data_state": "Posledné obnovenie údajov",
    "button.generate_report": "Vygenerovať správu",
    "moduleTitle.assessed_by_award_leader": "Hodnotené Vedúcim programu",
    "table.child_protection_number": "Číslo ochrany dieťaťa",
    "button.bulk_change": "Hromadná zmena",
    "label.send_welcome_email": "Poslať uvítací email",
    "label.award_state": "Stav v programe",
    "moduleTitle.overview": "Prehľad",
    "table.aj_detail": "Podrobnosti dobrodružnej expedície",
    "pageTitle.tasks_activity_approvals": "Schválenie aktivity",
    "label.section": "Sekcia",
    "route.history": "História",
    "route.event_participants": "Účastníci udalosti",
    "participant.account_detail": "Nastavenie konta",
    "route.dashboard": "Tabuľa",
    "table.payments": "Platby",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Odstrániť organizáciu",
    "pageTitle.my_organization": "Moja organizácia",
    "label.award_leader": "Vedúci",
    "notifications.assessor_has_been_updated": "Aktualizovali sa údaje hodnotiteľa",
    "label.participant_personal_reflection": "Účastníkova osobná reflexia",
    "button.add_key": "Pridať kľúč",
    "header.appMotto": "DUKE",
    "table.qualifying": "Kvalifikácia",
    "button.upload": "Nahrať",
    "button.resend": "Znova odoslať",
    "label.filename": "Názov súboru",
    "label.change_parental_consent": "Zmeniť súhlas rodiča.",
    "button.cancel": "Zrušiť",
    "label.aply_to_all_langs": "Použiť na všetky jazyky",
    "route.customization": "Prispôsobenie",
    "errors.minimal_duration_is": "Trvanie musí byť minimálne 30 min",
    "label.email_help_participant_first_name": "Krstné meno účastníka.",
    "label.participant_status": "Stav účastníka",
    "award.bronze_level_short": "Bronzová",
    "label.phone_type": "Typ telefónu",
    "global.night": "noc",
    "button.adventurous_journey_settings": "Nastavenie dobrodružnej expedície",
    "participant.leader_must_be_selected": "Vedúci musí byť vybratý",
    "pageTitle.translationsManagement": "Správca prekladov",
    "moduleTitle.user_added_preparation_and_training": "Používateľ pridal prípravu a tréning",
    "table.approve": "Schváliť",
    "label.role_in_organisation": "Rola v organizácii",
    "states.finished": "Ukončené",
    "label.created": "Vytvorené",
    "button.back_to_home": "Naspäť domov",
    "label.options": "Možnosti",
    "contact.next_level_invitation": "Pozvánka na ďalšiu úroveň",
    "moduleTitle.activity_detail": "Podrobnosti aktivity",
    "route.section_signoff": "Schválenie oblasti",
    "moduleTitle.assign_labels_bulk": "Priraď vybrané štítky k ${itemCount} účastníkom.",
    "button.contact_settings": "Nastavenie kontaktu",
    "label.transation_id": "ID transakcie",
    "notifications.activity_has_been_updated": "Aktivita bola aktualizovaná",
    "sidebar.awards": "Ocenenia",
    "parentalConsent.images_consent": "Ako rodič/poručník dávam svoj súhlas na použitie obrázkov a fotografií na propagačné ciele programu DofE.",
    "participant.would_you_like_to_delete": "Chcete toto konto odstrániť?",
    "roles.user": "Používateľ",
    "label.label": "Štítok",
    "label.select_sheet": "Vyberte hárok z vášho počítača",
    "global.no_results": "Žiaden výsledok",
    "moduleTitle.address_line_2": "Druhý riadok adresy",
    "states.awaiting_office_sign_off": "Čaká na schválenie kanceláriou",
    "moduleTitle.export": "Export",
    "moduleTitle.address_line_1": "Prvý riadok adresy",
    "notifications.participant_has_been_assigned": "Účastník bol priradený",
    "roles.viewer": "Používateľ s právami len na zobrazenie",
    "label.participants_total": "Celkový počet účastníkov",
    "errors.auth_code_is_no_longer_valid": "Potvrdzujúci kód už nie je platný – pravdepodobne už bol použitý alebo jeho platnosť vypršala",
    "label.file_is_not_available": "Dokument je nedostupný",
    "button.select_template": "Vybrať šablónu",
    "label.payment": "Platba",
    "award.silver_level_short": "Strieborná",
    "table.participant_id": "ID účastníka",
    "text.hours_old": "{hours} hodín staré",
    "moduleTitle.your_personal_information": "Osobné údaje",
    "aj.minimum_date_recommendation": "Minimálny odporúčaný dátum pre cvičnú dobrodružnú expedicíu a {name} je",
    "label.date_of_payment": "Dátum úhrady",
    "button.view": "Zobraziť",
    "label.create_new_label": "Vytvor nový štítok",
    "title.confirmation": "Potvrdenie",
    "button.set_participants": "Nastaviť účastníkov",
    "roles.assessor": "Hodnotiteľ",
    "moduleTitle.coordinator_settings": "Nastavenie koordinátora",
    "label.parent_relationship": "Vzťah rodiča",
    "table.nao": "Národná kancelária",
    "notifications.email_has_been_sent": "E-mail sa odoslal",
    "label.email_help_participant_full_name": "Celé meno účastníka.",
    "sidebar.suboperating_authorities": "Autorizovaní prevádzkovatelia na nižšej úrovni",
    "route.award": "DofE",
    "label.no_roles": "Žiadne role",
    "table.files": "Súbory",
    "aj.minimum_date_requirements": "Minimálne požiadavky na kvalifikačnú expedíciu a {name} sú",
    "pageTitle.labels": "Štítky",
    "label.participant_is_semi_offline": "Účastník je čiastočne papierový",
    "moduleTitle.other_coordinators": "Iní koordinátori",
    "button.updateSelectedLanguage": "Vybrať jazyk",
    "tasks.approve_award_registration": "Schváliť registráciu DofE",
    "participant.invite_participant_to_next_level": "Pozvať účastníka na ďalšiu úroveň?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Ocenenia",
    "warning.award_marked_as_paid": "Upozornenie: Existuje aspoň jedna úroveň ocenenia alebo registrácia označená ako zaplatená. Pred potvrdením si prečítajte pokyny pre platbu a vrátenie platby.",
    "table.edit": "Upraviť",
    "states.change_to_state_warning_missing_hours_to_complete": "UPOZORNENIE: Počet minimálne požadovaných hodín nebol zaznamenaný. Napriek tomu chcete pokračovať?",
    "label.dofe": "Medzinárodná cena",
    "moduleTitle.after_assigning_a_role_to_yourself": "Po pridelení alebo zmeny role je nutné sa znovu prihlásiť.",
    "label.transaction_id": "ID transakcie",
    "table.suboperating_authority": "Autorizovaný prevádzkovateľ na nižšej úrovni",
    "label.participant_survey": "Ako účastník DofE sa rád zúčastním prieskumov Nadácie DofE",
    "label.created_by": "Vytvoril/-a",
    "button.send_confirmation_email_again_question": "Znova poslať potvrdzujúci e-mail",
    "label.email_help_award_leader_email": "Email Vedúceho programu.",
    "label.name": "Meno",
    "tabs.gold_level": "Zlatá úroveň",
    "pageTitle.award_documents": "Dokumenty DofE",
    "label.online_payments": "Online platba",
    "label.child_protection_number": "Číslo ochrany dieťaťa",
    "participant.send_password_recovery_email": "Odoslať e-mail na obnovenie hesla?",
    "notifications.new_log_has_been_added": "Nový záznam pridaný",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Názov organizácie",
    "pageTitle.my_organization_templates": "Moja organizácia – šablóny",
    "pageTitle.award_leaders": "Vedúci programu",
    "label.status": "Stav",
    "label.street": "Ulica",
    "roles.if_staff_superuser": "Používateľ s vyššími právomocami – zamestnanec nadácie DofE",
    "table.licence_holder": "Držiteľ licencie",
    "label.created_at": "Vytvorené\n",
    "table.section": "Oblasť",
    "table.system_rights": "Systémové práva",
    "label.iac_type": "Typ Nezávislého centra DofE",
    "label.other": "Iné",
    "moduleTitle.login": "Prihlásenie",
    "label.no_data_to_show": "Žiadne údaje na zobrazenie",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Ak sú priradení účastníci, nemôžete upravovať úroveň DofE.",
    "tabs.waiting_payments": "Čaká sa na platby",
    "global.supervisor": "Školiteľ",
    "notifications.new_role_has_been_added": "Nová rola bola pridaná",
    "award.silver_level": "Strieborná úroveň",
    "heading.change_awards_mode": "Zmeniť režim ocenenia",
    "button.save_changes": "Uložiť zmeny",
    "organisation.would_you_like_to_move_award_unit": "Kde by ste chceli presunúť túto organizáciu?",
    "label.fields": "Označené polia",
    "label.email_help_organization_name": "Názov Miestneho centra.",
    "pageTitle.mro_related_detail": "Moja oblastná kancelária – Podrobnosti",
    "table.started_at": "Začiatok:",
    "parentalConsent.i_consent_to_the_award_unit": "2. Dávam súhlas Miestnemu centru a iným osobám, vrátane dobrovoľníkov, ktorí sú zapojení alebo pomáhajú s organizáciou programu DofE, a zazmluvneným vodičom dopravy, ktorí prepravujú účastníkov pre účely účasti na aktivitách alebo úlohách týkajúcich sa programu DofE, ak to bude potrebné. Beriem na vedomie, že Miestne centrum ma bude vopred informovať o tom, kedy a kde sa uskutoční takéto cestovanie.",
    "logs.minutes": "min.",
    "label.total_participants": "Celkový počet účastníkov",
    "moduleTitle.contact_info": "Kontaktné informácie",
    "table.payment_link": "Prepojenie na úhradu",
    "errors.please_contact_your_local_award_staff": "Obráťte sa na zamestnancov miestneho centra."
}